<template>
  <div>

    <b-row>
      <b-col>
        <h2>{{ trans('franchisee_settlements') }}</h2>
      </b-col>
      <b-col v-if="showForce" class="col-auto">
        <b-button
          v-for="force in force_buttons"
          :key="force.organization_id+'_'+force.start"
          v-if="organization.id == force.organization_id"
          :variant="isForceActive(force) ? 'outline-success' : 'outline-secondary'"
          size="sm"
          class="mr-2 mb-2"
          @click="onSetForceStartEnd(force)"
        >
          <i v-if="isForceActive(force)" class="fa fa-fw fa-check"></i>
          {{ force.label }}
        </b-button>
      </b-col>
      <b-col class="col-auto text-right">
        <b-dropdown
          :text="trans('month') + ': ' + (current ? current.format('MMM YYYY') : '')"
          variant="outline-secondary"
        >
          <b-dropdown-item
            v-for="month in months"
            v-bind:data="month"
            v-bind:key="month.format('YYYY-MM-DD')"
            @click.prevent="onCurrentChange(month)"
          >
            <i v-if="isCurrent(month)" class="fa fa-fw fa-check"></i>
            <i v-if="!isCurrent(month)" class="fa fa-fw"></i>
            {{ month.format('MMM YYYY') }}
          </b-dropdown-item>
        </b-dropdown>
        <a :href="downloadUrl" class="btn btn-outline-success ml-2">
          <i class="fa fa-fw fa-file-excel"></i>
        </a>
      </b-col>
    </b-row>

    <div class="alert alert-danger" v-if="!!error">{{ error }}</div>

    <b-row class="my-2">
      <b-col>
        <b-table
          ref="settlements"
          show-empty
          small
          bordered
          responsive
          sticky-header
          :items="settlements"
          :fields="settlementsFields"
          :busy="isBusy"
        >
          <template v-slot:empty="scope">
            <p v-if="!isBusy" class="text-center">
              {{ trans('no_records') }}
            </p>
            <p v-if="isBusy" class="text-center text-muted my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">{{ trans('loading') }}</strong>
            </p>
          </template>
          <template v-slot:cell(organization_name)="data">
            <a :href="`/organization/${data.item.organization_id}/report/transactions?start=${start}&end=${end}`" target="_blank">
              {{ data.item.organization_name }}
            </a>
            <amilia-financial-links
              :slug="data.item.organization_slug"
              :start="start"
              :end="end"
              size="sm"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  import queryString from 'query-string'
  import AmiliaFinancialLinks from './AmiliaFinancialLinksComponent'

  export default {
    components: {
      AmiliaFinancialLinks
    },
    props: [
      'organization',
      'amilia_organization',
      'user_id',
    ],
    data() {
      let months = []
      let m = moment('2019-08-01')
      let now = moment().startOf('month')
      while (m.isBefore(now)) {
        months.unshift(m.clone())
        m.add(1, 'month')
      }
      return {
        trans: trans,
        numeral: numeral,
        moment: moment,

        error: null,
        months: months,
        current: null,
        isBusy: false,

        settlements: null,
        settlementsFields: _.union([{
          key: 'organization_name',
          label: trans('franchisee'),
        }], _.map([
          'purchases',
          'cancellations',
          'discounts',
          'paid_amilia_online',
          'refunds_amilia',
          'paid_franchisee',
          'franchisee_refunds',
          'amilia_fees',
          'credit_card_fees',
          'tax_on_fees',
          'total_payments',
          'amilia_paid',
          'revenue_royalties',
          'tax_portion',
          'royalty_deducted',
          'total_to_be_paid',
        ], key => {
          return {
            key: key,
            label: trans('fsc_' + key),
            formatter: (value, key, item) => {
              return numeral(value).format('0,0.00')
            },
          }
        })),

        force_buttons: [
          {
            organization_id: 2,
            label: 'March 1-21, 2023',
            start: '2023-03-01',
            end: '2023-03-21'
          },
          {
            organization_id: 2,
            label: 'March 22-31, 2023',
            start: '2023-03-22',
            end: '2023-03-31'
          },
          {
            organization_id: 2,
            label: 'March 01-31, 2023',
            start: '2023-03-01',
            end: '2023-03-31'
          },
          {
            organization_id: 3,
            label: 'March 1-20, 2023',
            start: '2023-03-01',
            end: '2023-03-20'
          },
          {
            organization_id: 3,
            label: 'March 21-31, 2023',
            start: '2023-03-21',
            end: '2023-03-31'
          },
          {
            organization_id: 3,
            label: 'March 01-31, 2023',
            start: '2023-03-01',
            end: '2023-03-31'
          },
        ],
        force_start: null,
        force_end: null,
      }
    },
    computed: {
      showForce() {
        return [2, 3].indexOf(this.organization.id) >= 0 &&
          !!this.current &&
          this.current.format('YYYY-MM-DD') == '2023-03-01'
      },
      start() {
        if (!!this.force_start) return this.force_start
        return this.current ? this.current.format('YYYY-MM-DD') : null
      },
      end() {
        if (!!this.force_end) return this.force_end
        return this.current ? this.current.clone().endOf('month').format('YYYY-MM-DD') : null
      },
      downloadUrl() {
        return `/organization/${this.organization.id}/amilia/download_franchisee_settlements?start=${this.start}&end=${this.end}`
      },
    },
    methods: {
      isForceActive(force) {
        return this.force_start == force.start &&
          this.force_end == force.end ||
          !this.force_start &&
          !this.force_end &&
          !!this.current &&
          this.current.format('YYYY-MM-DD') == force.start &&
          moment(this.current).endOf('month').format('YYYY-MM-DD') == force.end
      },
      onSetForceStartEnd(force) {
        this.force_start = force.start
        this.force_end = force.end
        this.$nextTick(this.load)
      },
      onCurrentChange(month) {
        if (this.isCurrent(month)) return
        this.current = month
        this.force_start = null
        this.force_end = null
        this.$nextTick(() => {
          this.saveSettings()
          this.load()
        })
      },
      isCurrent(month) {
        return this.current && this.current.format('MMM YYYY') == month.format('MMM YYYY')
      },
      loadSettings() {
        const settings = _.extend({
            current: this.months[0],
          },
          _.getObjectFromLocalStorage('franchiseeSettlementsReportSettings'),
          _.pick(queryString.parse(location.search), 'current'),
        )
        this.current = settings.current ? moment(settings.current) : this.months[0]
        this.saveSettings();
      },
      saveSettings() {
        const settings = {
          current: this.current.format('YYYY-MM-DD'),
        }

        // Replace query string
        history.replaceState({}, null, window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + queryString.stringify(settings))

        // Save to local storage
        window.localStorage['franchiseeSettlementsReportSettings'] = JSON.stringify(settings)
      },
      load() {
        if (!this.current) return
        const url = `/organization/${this.organization.id}/amilia/franchisee_settlements?start=${this.start}&end=${this.end}`

        this.isBusy = true
        this.error = false

        return axios.get(url)
        .then(response => {
          this.isBusy = false
          this.settlements = response.data
        })
        .catch(error => {
          this.isBusy = false
          if (error.response.data) {
            this.error = error.response.data.errors ? _.values(error.response.data.errors).join(' ') : error.response.data.message
          } else {
            this.error = error
          }
          if (!this.error) this.error = trans('error')
        })
      },
    },
    mounted() {
      window.co = this
      this.loadSettings()
      this.load()
    }
  }
</script>